<template>
    <div id="lookup-user">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn :color="primaryColor" dark small v-bind="attrs" v-on="on" @click.stop="openDialog()">
                    <v-icon>mdi-account-search</v-icon>
                </v-btn>
            </template>
            <span>Lookup User</span>
        </v-tooltip>
        <v-dialog v-model="dialog" max-width="767" persistent>
            <v-card ref="lookupUserCard">
                <v-card-title>
                    Lookup User
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-form ref="userSearchForm" v-model="valid" lazy-validation v-on:submit.prevent>
                        <v-text-field v-model="searchTerm" label="Search Term" :rules="searchTermRules" required
                            @keydown.enter="search()">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="searchBtn" class="white--text" :color="primaryColor" @click="search()">
                        Search
                    </v-btn>
                    <v-btn ref="resetBtn" :color="warningColor" @click="resetSearch()">
                        Reset
                    </v-btn>
                </v-card-actions>
                <v-card-text class="pb-0">
                    <v-divider class="pb-2"></v-divider>
                    <v-data-table :headers="searchHeaders" :items="searchItems" sort-by="cn">
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :color="successColor" icon v-bind="attrs" v-on="on"
                                        @click="selectUser(item)">
                                        <v-icon>
                                            mdi-account-check
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Add User</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="warningColor" @click="closeDialog()">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'lookup-user',
    data() {
        return {
            dialog: false,
            searchHeaders: [{
                    text: 'Name',
                    align: 'start',
                    value: 'cn',
                },
                {
                    text: 'Username',
                    value: 'username',
                },
                {
                    text: 'Mail',
                    value: 'mail',
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions'
                }
            ],
            searchItems: [],
            searchTerm: '',
            searchTermRules: [
                v => !!v || 'Search term is required',
                v => (v && v.length >= 2) || 'Search term must be more than 2 characters',
            ],
            valid: true
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        openDialog() {
            this.resetSearch();
            this.dialog = true;
        },
        resetSearch() {
            if (this.$refs.userSearchForm) {
                this.$refs.userSearchForm.resetValidation();
            }

            this.searchItems = [];
            this.searchTerm = '';
        },
        search() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?search&type=student&term=${this.searchTerm}`;
            this.$refs.searchBtn.loading = true;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/OK/i)) {
                        that.searchItems = json.data;
                        that.$emit('setNotification', '#1dc9b7', 'mdi-account-search',
                            `Search found ${json.data.length} matching record(s) using the term "${that.searchTerm}".`,
                            true);
                    } else {
                        that.searchItems = [];
                        that.$emit('setNotification', '#ffb822', 'mdi-account-alert',
                            `No matching record(s) found using the term "${that.searchTerm}".`, true);
                    }

                    that.$refs.searchBtn.loading = false;
                })
                .catch(function () {
                    that.$refs.searchBtn.loading = false;
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-circle',
                        'An error occurred. Please contact your system administrator.', true);
                })
        },
        selectUser(user) {
            this.$emit('selectUser', user);
            this.closeDialog();
        }
    },
    computed: {
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>